import React from 'react'
import Prods from '../components/Prods'

const Produits = () => {
  return (
    <div>
        <Prods /> 
    </div>
  )
}

export default Produits